import React from "react";
import GridBlock from "components/GridBlock";
import {TextField, withStyles} from "@material-ui/core";
import Tr from "translations/Translations";
import SimpleSelect from "components/SimpleSelect";
import Button from "components/Button";
import AddIcon from "@material-ui/icons/Add";
import orderTypes from "constants/orderType.values"
import DateFormats from "constants/DateFormats";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import {VALUES} from "../constants/AuditTaskAllowedObjectType"
import WorkableIconButton from "components/button/WorkableIconButton";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "components/button/IconButton";
import ClearIcon from "@material-ui/icons/Clear";

const style = theme => ({
    root: {
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    spaceRight: {
        marginRight: theme.spacing(4)
    },
    gridWrapper: {
        '&:first-child': {
            width: 'calc(100% - 200px)'
        },
        '&:last-child': {
            width: '200px'
        }
    },
    search: {
        width: 250,
        marginBottom: theme.spacing(1)
    },
    chipsGrid: {
        marginTop: theme.spacing(1)
    },
    select: {
        width: 250,
        marginBottom: theme.spacing(1)
    },
    date: {
        width: 250,
        marginBottom: theme.spacing(1)
    },
    icon: {
        paddingRight: theme.spacing(1)
    }
})

function AuditTaskAllowedObjectSearchBar({
    pickObjects,
    objectType,
    classes,
    filters,
    setFilters,
    onSubmit,
    onReset,
    searching
}) {

    const orderTypesWithBlank = [{label: '', value: ''}, ...orderTypes];

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            onSubmit();
        }
    }

    return (
        <>
            <GridBlock
                alignItems='flex-start'
                justify='space-between'
                itemClassName={classes.gridWrapper}
            >
                <GridBlock
                    alignItems='flex-end'
                    className={classes.root}
                    itemClassName={classes.spaceRight}
                >
                    <TextField
                        className={classes.search}
                        label={Tr('audit_task_allowed_objects_name_' + objectType.toLowerCase())}
                        onChange={e => setFilters({...filters, name: e.target.value})}
                        onKeyUp={handleKeyUp}
                        value={filters.name}
                        fullWidth

                    />
                    <TextField
                        className={classes.search}
                        label={Tr('audit_task_allowed_objects_number_' + objectType.toLowerCase())}
                        onChange={e => setFilters({...filters, number: e.target.value})}
                        onKeyUp={handleKeyUp}
                        value={filters.number}
                        fullWidth

                    />
                    {VALUES.AGREEMENT !== objectType && <SimpleSelect
                        label={Tr('order_type')}
                        className={classes.select}
                        items={orderTypesWithBlank}
                        onChange={(e) => setFilters({...filters, orderType: e.target.value})}
                        value={filters.orderType}
                    />}
                    {VALUES.PURCHASE_REQUEST !== objectType && <KeyboardDateTimePicker
                        className={classes.date}
                        label={Tr('audit_task_allowed_objects_dateStart_' + objectType.toLowerCase())}
                        ampm={false}
                        format={DateFormats.DATETIME_FORMAT}
                        variant='dialog'
                        cancelLabel={Tr('cancel')}
                        value={filters.dateStart}
                        invalidDateMessage={Tr("invalid_date_format")}
                        onChange={e => setFilters({...filters, dateStart: (e ? e : null)})}
                    />}
                    {VALUES.PURCHASE_REQUEST !== objectType && <KeyboardDateTimePicker
                        className={classes.date}
                        label={Tr('audit_task_allowed_objects_dateEnd_' + objectType.toLowerCase())}
                        ampm={false}
                        format={DateFormats.DATETIME_FORMAT}
                        variant='dialog'
                        cancelLabel={Tr('cancel')}
                        value={filters.dateEnd}
                        invalidDateMessage={Tr("invalid_date_format")}
                        onChange={e => setFilters({...filters, dateEnd: (e ? e : null)})}
                    />}
                    <div>
                        <WorkableIconButton Icon={SearchIcon} working={searching} onClick={onSubmit} tooltip={Tr('search')}/>
                        <IconButton disabled={searching} Icon={ClearIcon} tooltip={Tr('clear')} onClick={onReset}/>
                    </div>
                </GridBlock>
                <GridBlock
                    alignItems='flex-end'
                    justify='flex-end'
                >
                    <Button
                        className={classes.buttonNew}
                        color={'primary'}
                        variant={undefined}
                        onClick={pickObjects}

                    >
                        <AddIcon className={classes.icon}/>
                        {Tr('confirm2')}
                    </Button>
                </GridBlock>
            </GridBlock>
        </>
    )

}

export default withStyles(style)(AuditTaskAllowedObjectSearchBar);